module.exports = __webpack_public_path__ + "static/media/blackbox.cd320458.png";